var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"cursor-pointer text-white ds-text-xl p-1",class:_vm.iconClass,on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }